export const TIPO_ERROR = 'TIPO_ERROR'
export const GET_CHART_STATUS = 'GET_CHART_STATUS'
export const GET_CHART_POINT_STATUS = 'GET_CHART_POINT_STATUS'
export const GET_CHART_ALARME = 'GET_CHART_ALARME'
export const GET_CHART_SENSOR_STATUS = 'GET_CHART_SENSOR_STATUS'
export const GET_CHART_NODE_STATUS = 'GET_CHART_NODE_STATUS'
export const GET_CHART_SENSOR_BATTERY = 'GET_CHART_SENSOR_BATTERY'





// WEBPACK FOOTER //
// ./src/store/actions/chartsOnline.js